module.exports = __webpack_public_path__ + "assets/img/Fotolia_190049489_XS.7717d855.jpg";